const deleteClientIdFromUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('clientId');
  window.history.replaceState(null, 'Replace url', url.href);
};

export default deleteClientIdFromUrl;
